(ns app.domain.application.shared-core)


(defn normalized-review-created-state [created-in-state]
  (case created-in-state
    (:process.state/in-review :process.state/submitted) created-in-state
    :process.state/submission-changes-requested :process.state/submitted
    :process.state/submission-awaiting-sign-off :process.state/submitted
    :state.application/in-review :process.state/in-review
    :state.application/submitted :process.state/submitted
    :state.application/submission-changes-requested :process.state/submitted
    :state.application/submission-awaiting-sign-off :process.state/submitted
    nil))

(defn review-created-in-current-step?
  "Returns true when the review is in the same review step as the application.
   Reviews created in :process.state/submitted match only while the application is in
   :process.state/submitted. Reviews with missing or unrecognized :review/created-in-state
   values are not treated as current-step reviews."
  [application review]
  (let [review-created-state (-> review :review/created-in-state normalized-review-created-state)
        app-state            (normalized-review-created-state (or (:process/state application)
                                                                  (:domain/state application)))]
    (= (= :process.state/submitted review-created-state)
       (= :process.state/submitted app-state))))


(defn all-reviews-ended?
  "Returns true if there are no current-step reviews, or every current-step review has :review/end timestamp set."
  [application]
  (->> application
       :entity/_parent
       (filter #(-> % :entity/type (= :entity.type/review)))
       (filter #(review-created-in-current-step? application %))
       (every? :review/end)))
